import { G2ComparisonType } from '../components/G2Comparison'
import { AlternativeType } from '../types'
import ApideckLogo from './images/api-deck-logo.svg'
import ApideckIcon from './images/api-deck-icon.svg'

export const linkToG2 =
  'https://www.g2.com/compare/apideck-unify-vs-integration-app'

export const g2Comparison: G2ComparisonType = {
  name: 'Apideck',
  logo: ApideckLogo.src,
  stars: 5,
  reviews: 41,
  markerSegment: (
    <>
      <b>Small-Business</b> (82.5% of reviews)
    </>
  ),
  entryLevelPricing: (
    <>
      <b>Free</b> 2500 API requests
    </>
  ),
}

export const alternative: AlternativeType = {
  name: 'ApiDeck',
  logo: ApideckLogo,
  icon: ApideckIcon,
}
